export default __webpack_public_path__ + "static/media/ic-fruit-apples.7db36e32.svg";